// extracted by mini-css-extract-plugin
export var statItem = "_ip-1";
export var statsRow = "_ip-0";